<template>
    <v-app>
      <v-container v-if="!hayUsuario">
        <Login/>
      </v-container>
      <v-container v-else>
        <v-img
          class ="fondo"
          src = "@/assets/fondo.png"
          contain
          max-height = "1000"
          max-width = "1000">
        </v-img>
      </v-container>
      <v-dialog v-model = "dialogCambiar" max-width="500" persistent>
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>Cambio de contraseña</v-card-title>
          <v-card-text>
            <strong>Usted ha ingresado con una contraseña automática, por favor ingrese su nueva clave.</strong>
            <v-text-field
            label = "Nueva clave"
            v-model ="pass"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1">
            </v-text-field>
            <v-text-field
            label = "Repita la clave"
            v-model ="pass2"
            :append-icon="show2 ? 'visibility' : 'visibility_off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2">
            </v-text-field>
            <p v-if="showWarning"><b>Las contraseñas no coinciden.</b></p>
          </v-card-text>
          <v-card-actions class ="justify-end">
            <v-btn @click="cambiarContraseña()">Cambiar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>

</template>
<style scoped>
  .fondo{
    opacity: 0.75;
  }
</style>
<script>
import axios from 'axios';
import Login from '@/components/Login.vue';
import { url } from '@/variables';

export default {
  name: 'Inicio',
  components: {
    Login,
  },
  data() {
    return {
      hayUsuario: this.$session.get('id') > 0,
      dialogCambiar: false,
      show1: false,
      show2: false,
      pass: '',
      pass2: '',
      showWarning: false,
      eventos: [
        {
          name: 'Partido',
          start: '2019-08-29',
          color: 'cyan',
        },
      ],
      picker: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      });
    },
  },
  methods: {
    init() {
      if (this.hayUsuario) {
        this.dialogCambiar = this.$session.get('temp');
      }
    },
    cambiarContraseña() {
      if (this.pass === this.pass2) {
        const path = `${url}/cambiarContraseniaId`;
        axios.post(path, {
          id: this.$session.get('id'),
          pass: this.pass,
        })
          .then((response) => {
            if (response.data.msg === 'Ok') {
              this.dialogCambiar = false;
              this.$session.remove('temp');
            }
          });
      } else {
        this.showWarning = true;
      }
    },
    getEventColor(event) {
      return event.color;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
